import { Heading } from '../../r2/Heading';
import { Text } from '../../r2/Text';
import { Image } from '../../r2/Image';
import styles from './CharacterCard.module.css';

export interface CharacterCardProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  category: string;
  body: string;
  quote: string;
  attribution: string;
}

export function CharacterCard({
  imageSrc,
  imageAlt,
  title,
  category,
  body,
  quote,
  attribution,
}: CharacterCardProps) {
  return (
    <div data-crd-id="r3.bq-character-card" data-crd-layer="r3" className={styles.card}>
      <div className={styles.header}>
        <Image
          src={imageSrc}
          alt={imageAlt}
          width={150}
          loading="lazy"
          className={styles.avatar}
        />
        <Heading level={3} as={3} align="center">
          {title}
        </Heading>
      </div>
      <div className={styles.bodyWrap}>
        <Text size="r2" weight="bold">
          {category}
        </Text>
        <Text size="r2" className={styles.body}>
          {body}
        </Text>
      </div>
      <Text size="r2" weight="bold" align="center" className={styles.quote}>
        {quote}
        <br />- {attribution}
      </Text>
    </div>
  );
}
